import { useLocation } from "react-router-dom";
import ProfileAvatar from "./ProfileAvatar";
import ProfileInfoLine from "./Profile-info-line";

const Header = () => {
  const location = useLocation();

  const isAppPage = location.pathname === "/";

  return (
    <div
      className={`w-full h-28 py-4 flex justify-between items-end gap-2 px-5 xs:px-2 ${
        isAppPage
          ? "z-50 absolute top-0 bg-gradient-to-b from-overlay-40 to-overlay-0"
          : "bg-primary"
      }`}
    >
      <ProfileInfoLine />
      <ProfileAvatar />
    </div>
  );
};

export default Header;
